unit InstrumentItemListType;

interface

uses
  InstrumentItemType;

type
  TInstrumentItemListType = array of TInstrumentItemType;

implementation

end.
